export default __webpack_public_path__ + "static/media/img2.6dbe58b9.png";